export const GET_CUSTOMER_ACCOUNT_DATA = 'GET_CUSTOMER_ACCOUNT_DATA';
export const UPDATE_CUSTOMER_ACCOUNT_DATA = 'UPDATE_CUSTOMER_ACCOUNT_DATA';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
